export const SecurityActionType = Object.freeze({
  SET_PWD_RESET_DIALOG_VISIBILITY:
    "Security:: Set password reset dialog visibility",
  SET_PWD_STRENGTH_DIALOG_VISIBILITY:
    "Security:: Set password strength dialog visibility",
  SET_SETTINGS: "Security:: Set Settings",
  CHANGE_POLICY: "Security:: Set password policy",
});
